/**
 * Forecast mission — registered in the Atlas Dock but delegates storage to the
 * existing ForecastTourStep machine in `onboardingState.ts`. Phase 1 is
 * read-only: the ForecastPage keeps its own tour code untouched.
 */
import type { AtlasMission } from '../atlas.types';

export const forecastMission: AtlasMission = {
  id: 'forecast-tour',
  title: 'Walk the Forecast dashboard',
  description: 'Summary, filters, release planning, and the task table.',
  kicker: 'Guided tour',
  estimatedMinutes: 3,
  entryRoute: '/forecast',
  featureKey: 'forecast',
  storage: 'forecast',
  steps: [
    {
      id: 'welcome',
      title: 'What is Forecast?',
      body: 'Forecast answers: when will this backlog be done?',
    },
    {
      id: 'summary',
      title: 'Read the summary block',
      body: 'Remaining effort, grouped by priority.',
      anchorId: 'forecast-summary-anchor',
    },
    {
      id: 'filters',
      title: 'Tune your filters',
      body: 'Priority, issue type, status, cluster, component, label.',
      anchorId: 'forecast-filters-anchor',
    },
    {
      id: 'tasks',
      title: 'Inspect the task table',
      body: 'One row per task with estimate, remaining, release.',
      anchorId: 'forecast-table-anchor',
    },
    {
      id: 'distribute',
      title: 'Plan releases',
      body: 'Prerequisite: mark at least some teammates as QA in Settings → Team — required for Dev/QA split and "Suggest from history". Then pick a target version, set bug reserve and Dev/QA split, and suggest distribution. Per-person task rules are configured on the same Team page.',
      anchorId: 'forecast-distribute-anchor',
    },
  ],
};
